import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export type BulkVosVosFormViewResult = {
  osiSubmissionCode: number
  appointmentCode: number
  vosSubmissionMode?: number
  fileName?: string
  viewUrl?: string
  documentCode?: string
  openDigitalViewer?: boolean
}

function normalizeVosFormView(raw: unknown): BulkVosVosFormViewResult | null {
  const row = (raw as {result?: unknown; Result?: unknown})?.result
    ?? (raw as {result?: unknown; Result?: unknown})?.Result
    ?? raw
  if (!row || typeof row !== 'object') return null
  const r = row as Record<string, unknown>
  const osiSubmissionCode = Number(r.osiSubmissionCode ?? r.OsiSubmissionCode ?? 0)
  const appointmentCode = Number(r.appointmentCode ?? r.AppointmentCode ?? 0)
  if (!osiSubmissionCode || !appointmentCode) return null
  return {
    osiSubmissionCode,
    appointmentCode,
    vosSubmissionMode:
      r.vosSubmissionMode != null || r.VosSubmissionMode != null
        ? Number(r.vosSubmissionMode ?? r.VosSubmissionMode)
        : undefined,
    fileName: (r.fileName ?? r.FileName) as string | undefined,
    viewUrl: (r.viewUrl ?? r.ViewUrl) as string | undefined,
    documentCode: (r.documentCode ?? r.DocumentCode) as string | undefined,
    openDigitalViewer: Boolean(r.openDigitalViewer ?? r.OpenDigitalViewer),
  }
}

export async function fetchBulkVosVosFormView(
  itemId: number,
  portalToken?: string,
): Promise<BulkVosVosFormViewResult> {
  const url = portalToken
    ? `${API_URL}/bulk-vos/batch/${encodeURIComponent(portalToken)}/items/${itemId}/vos-form-view`
    : `${API_URL}/bulk-vos/items/${itemId}/vos-form-view`
  const res = await axios.get(url)
  const status = res.data?.status ?? res.data?.Status
  if (status !== 'S') {
    const msg = res.data?.text ?? res.data?.Text ?? 'Unable to load VOS form'
    throw new Error(String(msg))
  }
  const parsed = normalizeVosFormView(res.data)
  if (!parsed) throw new Error('Unable to load VOS form')
  return parsed
}
